import React from 'react';

const Logo = () => (
  <svg
    width="191"
    height="69"
    viewBox="0 0 191 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M83.648 45L82.4 40.92H76.16L74.912 45H71L77.048 27.792H81.488L87.56 45H83.648ZM80.288 33.888C80.208 33.616 80.104 33.272 79.976 32.856C79.848 32.44 79.72 32.016 79.592 31.584C79.464 31.152 79.36 30.776 79.28 30.456C79.2 30.776 79.088 31.176 78.944 31.656C78.816 32.12 78.688 32.568 78.56 33C78.448 33.416 78.36 33.712 78.296 33.888L77.072 37.872H81.536L80.288 33.888Z"
      fill="currentColor"
    />
    <path
      d="M96.1383 45H88.3383V42.936L90.4263 41.976V30.888L88.3383 29.928V27.864H96.1383V29.928L94.0503 30.888V41.976L96.1383 42.936V45Z"
      fill="currentColor"
    />
    <path
      d="M104.05 27.864C106.386 27.864 108.106 28.288 109.21 29.136C110.33 29.984 110.89 31.272 110.89 33C110.89 33.784 110.738 34.472 110.434 35.064C110.146 35.64 109.754 36.136 109.258 36.552C108.778 36.952 108.258 37.28 107.698 37.536L112.738 45H108.706L104.626 38.424H102.682V45H99.0584V27.864H104.05ZM103.786 30.84H102.682V35.472H103.858C105.058 35.472 105.914 35.272 106.426 34.872C106.954 34.472 107.218 33.88 107.218 33.096C107.218 32.28 106.938 31.704 106.378 31.368C105.834 31.016 104.97 30.84 103.786 30.84Z"
      fill="currentColor"
    />
    <path
      d="M125.006 40.248C125.006 41.768 124.454 42.984 123.35 43.896C122.262 44.792 120.71 45.24 118.694 45.24C116.886 45.24 115.27 44.896 113.846 44.208V40.824C114.662 41.176 115.502 41.504 116.366 41.808C117.246 42.096 118.118 42.24 118.982 42.24C119.878 42.24 120.51 42.072 120.878 41.736C121.262 41.384 121.454 40.944 121.454 40.416C121.454 39.984 121.302 39.616 120.998 39.312C120.71 39.008 120.318 38.728 119.822 38.472C119.326 38.2 118.758 37.912 118.118 37.608C117.718 37.416 117.286 37.192 116.822 36.936C116.358 36.664 115.91 36.336 115.478 35.952C115.062 35.552 114.718 35.072 114.446 34.512C114.174 33.952 114.038 33.28 114.038 32.496C114.038 30.96 114.558 29.768 115.598 28.92C116.638 28.056 118.054 27.624 119.846 27.624C120.742 27.624 121.59 27.728 122.39 27.936C123.206 28.144 124.054 28.44 124.934 28.824L123.758 31.656C122.974 31.336 122.27 31.088 121.646 30.912C121.022 30.736 120.382 30.648 119.726 30.648C119.038 30.648 118.51 30.808 118.142 31.128C117.774 31.448 117.59 31.864 117.59 32.376C117.59 32.984 117.862 33.464 118.406 33.816C118.95 34.168 119.758 34.6 120.83 35.112C121.71 35.528 122.454 35.96 123.062 36.408C123.686 36.856 124.166 37.384 124.502 37.992C124.838 38.6 125.006 39.352 125.006 40.248Z"
      fill="currentColor"
    />
    <path
      d="M133.593 27.864C135.801 27.864 137.409 28.344 138.417 29.304C139.441 30.248 139.953 31.552 139.953 33.216C139.953 34.208 139.745 35.144 139.329 36.024C138.913 36.888 138.217 37.584 137.241 38.112C136.281 38.64 134.969 38.904 133.305 38.904H131.745V45H128.121V27.864H133.593ZM133.401 30.84H131.745V35.928H132.945C133.969 35.928 134.777 35.728 135.369 35.328C135.977 34.912 136.281 34.248 136.281 33.336C136.281 31.672 135.321 30.84 133.401 30.84Z"
      fill="currentColor"
    />
    <path
      d="M152.484 45L151.236 40.92H144.996L143.748 45H139.836L145.884 27.792H150.324L156.396 45H152.484ZM149.124 33.888C149.044 33.616 148.94 33.272 148.812 32.856C148.684 32.44 148.556 32.016 148.428 31.584C148.3 31.152 148.196 30.776 148.116 30.456C148.036 30.776 147.924 31.176 147.78 31.656C147.652 32.12 147.524 32.568 147.396 33C147.284 33.416 147.196 33.712 147.132 33.888L145.908 37.872H150.372L149.124 33.888Z"
      fill="currentColor"
    />
    <path
      d="M165.369 30.648C163.977 30.648 162.913 31.168 162.177 32.208C161.441 33.248 161.074 34.672 161.074 36.48C161.074 38.304 161.409 39.72 162.081 40.728C162.769 41.72 163.865 42.216 165.369 42.216C166.073 42.216 166.77 42.136 167.458 41.976C168.162 41.816 168.922 41.592 169.738 41.304V44.352C168.986 44.656 168.242 44.88 167.506 45.024C166.77 45.168 165.946 45.24 165.034 45.24C163.274 45.24 161.817 44.88 160.665 44.16C159.529 43.424 158.69 42.4 158.146 41.088C157.602 39.76 157.329 38.216 157.329 36.456C157.329 34.728 157.642 33.2 158.266 31.872C158.89 30.544 159.794 29.504 160.978 28.752C162.178 28 163.641 27.624 165.369 27.624C166.217 27.624 167.065 27.736 167.913 27.96C168.777 28.168 169.601 28.456 170.385 28.824L169.21 31.776C168.57 31.472 167.922 31.208 167.266 30.984C166.626 30.76 165.993 30.648 165.369 30.648Z"
      fill="currentColor"
    />
    <path
      d="M183.243 45H173.379V27.864H183.243V30.84H177.003V34.608H182.811V37.584H177.003V42H183.243V45Z"
      fill="currentColor"
    />
    <path
      d="M186.016 43.32C186.016 42.584 186.216 42.072 186.616 41.784C187.016 41.48 187.504 41.328 188.08 41.328C188.64 41.328 189.12 41.48 189.52 41.784C189.92 42.072 190.12 42.584 190.12 43.32C190.12 44.024 189.92 44.536 189.52 44.856C189.12 45.16 188.64 45.312 188.08 45.312C187.504 45.312 187.016 45.16 186.616 44.856C186.216 44.536 186.016 44.024 186.016 43.32Z"
      fill="currentColor"
    />
    <path d="M0 0L40 7.5V52.5L0 60V0Z" fill="#4460F1" />
    <path
      d="M9 9L49 16.5V61.5L9 69V9Z"
      fill="#5796FF"
      style={{ mixBlendMode: 'multiply' }}
    />
  </svg>
);

const Favicon = () => (
  <svg
    width="49"
    height="69"
    viewBox="0 0 49 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0L40 7.5V52.5L0 60V0Z" fill="#4460F1" />
    <path
      d="M9 9L49 16.5V61.5L9 69V9Z"
      fill="#5796FF"
      style={{ mixBlendMode: 'multiply' }}
    />
  </svg>
);

export { Logo, Favicon };
